import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js'
import './nlp/tabler.css';


function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring( o ){ return typeof(o) == 'string';}
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig,'').toLowerCase() }
function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return false;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

function sbool( v )
{
	return ['No','Yes'][v];
}

var companyList = [];
function getCompanies( callback )
{
	if( companyList.length ) callback( companyList )
	window.post( 'find_companies', {match:{active:true}}, function(res){
		if( res.status ) companyList = res.data.records;
		console.log( 'companyList', companyList );
		callback( companyList );
	})
}

function Logs(prop) {

    var global = window.GlobalVars;
    var tab;


    useEffect( function(a){
        $('#topbuttons').html(`<div class="logstable">
			<table><tr>
			<td>
				<label for="email" class="email">User Email</label>
				<input placeholder="User Email" type="email" id="email" class="mb-4 form-control email">
			</td>
			<td>
				<label for="action" class="email">Action</label>
				<select placeholder="Action" type="text" id="action" class="mb-4 form-control lmr">
				<option></option>
				<option>account_update</option>
				<option>create_company</option>
				<option>create_user</option>
				<option>dataset_upload</option>
				<option>delete_user_role</option>
				<option>insert_user_role</option>
				<option>login</option>
				<option>project_delete</option>
				<option>project_update</option>
				<option>project_upload</option>
				<option>set_new_api_key</option>
				<option>task_update</option>
				<option>task_upload</option>
				<option>update_user</option>
				<option>update_user_role</option>
				</select>
			</td>
			<td>
				<label for="project" class="email">Project ID</label>
				<input placeholder="Project ID" type="email" id="project" class="mb-4 form-control email">
			</td>
			<td>
				<label for="fileId" class="email">Task ID</label>
				<input placeholder="Task ID" type="email" id="fileId" class="mb-4 form-control email">
			</td>
			<td>
				<button id="search" class="btn btn-primary ml-4"> <i class="fa fa-search mr-2" aria-hidden="true"></i>Search</button>
			</td>
			</tr></table></div>
			`);


			// <td>
			// 	<label for="limit" class="email">Max result</label>
			// 	<select id="limit" class="mb-4 form-control">
			// 	<option>50</option>
			// 	<option>100</option>
			// 	<option>200</option>
			// 	<option>300</option>
			// 	<option>400</option>
			// 	</select>
			// </td>


			$('#search').on('click', searchLogs );

			function dateTs( ts )
			{
				// return ts;
				return new Date( ts*1000 ).toLocaleString()
			}

			searchLogs();
			function searchLogs(){
				$('#documentlist').html('');
				$('#documentlist').show();
				$('.alert').remove();
				var match = {};
				if( $('#email').val().trim() ) match.email = $('#email').val().trim();
				if( $('#action').val().trim() ) match.action = $('#action').val().trim();
				if( $('#project').val().trim() ) match.project = $('#project').val().trim();
				if( $('#fileId').val().trim() ) match.fileId = $('#fileId').val().trim();
				console.log( 'MATCH', match );
				window.post( 'find_logs', match, function(res){
					console.log( 'logs', res.data );
					var logs = res.data;
					if( !logs.length )
					{
						$('.alert').remove();
						var empty = $('<div role="alert" class="fade alert alert-danger show">').html('No log entries found');
						$('#topbuttons').append(empty);
						$('#documentlist').hide();
					}
					var desc = {
						title: 'User Log',
						columns: {
							// _id: 'Id',
							ts: 'Date/Time',
							email: 'User',
							companyName: 'Company',
							action: 'Action',
							// active:'Active',
						},
						filter: true,
						search: true,
						sort: true,
						// sortAlias: { lastLoginDelta: 'lastLogin' },
						initialSort: 'date_time',
						initialSortDir: -1,
						pageSize: 50,
						// noFilter: ['lastLogin'],
						noSearch: null,
						noSort: null,
						// centerCol: ['created','lastLogin','active'],
						format: tabler.formatString,
						formatCol: {
							ts: dateTs,
							// lastLogin:tabler.formatTimeAgo,
							// created:tabler.formatDate,
							// priv:tabler.formatPriv,
							// active: tabler.formatActive,
						},
						// forceType:{ lastLogin: 1, active: 1, created: 1 },
						headerClick: 'filter',
						// clickCol: ['stateLabel','source'],
					}
					tab = tabler.table($('#documentlist'), desc, global.userTableCtx );
					logs.forEach( a => {
						tab.addRow(a, function( col, row ){
							console.log( 'tabler click', a._id, row[col], row )
							var json = clone(row);
							delete json._id;
							json = JSON.stringify(json,null,'    ');
							frm.myAlert( 'Log Detail', '<pre>'+json+'</pre>', 'Close');
							// editUser( row );
							// fileClickTabler( col, row )
						})
					});
					tab.draw();
					// console.log( 'desc', desc, 'tabler', tabler.formatString )
				});
			}
			frm.convertSelects($('select'));
    });

    return (
        <div fluid="md p-0" className="maincontent">
        <div id="topbuttons"></div>
        <Table id="documentlist" bordered hover size="sm" className="table-grid mt-3">
        </Table>
        <span>&nbsp;</span>
        </div>
    )
}

export default Logs
